<template>
  <div id="login-container" v-loading.body="alterLoginLoading">
    <div class="title">
      <span style="font-size: 36px; color: #f8fafc">{{ title }}</span>
    </div>
    <div class="login-div">
      <el-row class="row-container">
        <el-col :span="12" class="left-col">
          <div style="width: 100%; height: 100%">
            <img
              src="@/assets/logo-left.png"
              alt
              style="height: auto; max-height: 100%"
            />
          </div>
        </el-col>
        <el-col :span="12" class="right-row-container">
          <div style="width: 330px; marin-top: 30px">
            <div style="color: #42464f">
              <span
                v-for="type in loginTypes"
                :key="type.value"
                :class="
                  loginType === type.value ? 'login-type active' : 'login-type'
                "
                @click="changeLoginType(type.value)"
                >{{ type.name }}</span
              >
            </div>

            <el-form
              ref="loginForm"
              :model="loginForm"
              :rules="rules"
              class="login-form"
              label-position="left"
              label-width="0px"
              v-loading="loading"
            >
              <el-form-item
                v-if="loginType === '1'"
                prop="username"
                style="text-align: left"
              >
                <label for="username" class="common-label">手机号</label>
                <el-input
                  id="username"
                  type="text"
                  v-model="loginForm.username"
                  auto-complete="off"
                  placeholder="请输入手机号"
                ></el-input>
              </el-form-item>
              <el-form-item
                v-if="loginType === '2'"
                prop="idCard"
                style="text-align: left"
              >
                <label for="username" class="common-label">身份证号</label>
                <el-input
                  id="username"
                  type="text"
                  v-model="loginForm.idCard"
                  auto-complete="off"
                  placeholder="请输入身份证号"
                ></el-input>
              </el-form-item>
              <el-form-item
                v-if="loginType === '3'"
                prop="username"
                style="text-align: left"
              >
                <label for="username" class="common-label"
                  >用户名 / 手机号</label
                >
                <el-input
                  id="username"
                  type="text"
                  v-model="loginForm.username"
                  auto-complete="off"
                  placeholder="请输入用户名或手机号"
                ></el-input>
              </el-form-item>
              <el-form-item prop="password" style="text-align: left">
                <label for="password" class="common-label">密码</label>
                <el-input
                  id="password"
                  type="password"
                  v-model="loginForm.password"
                  auto-complete="off"
                  placeholder="请输入密码"
                ></el-input>
              </el-form-item>
              <el-form-item prop="capcha" class="capcha-form-item">
                <label for="capcha" class="capcha-label">验证码</label>
                <el-input
                  type="text"
                  id="capcha"
                  v-model="loginForm.capcha"
                  placeholder="请输入验证码"
                  auto-complete="off"
                ></el-input>
                <vue-img-verify @getImgCode="getImgCode" ref="vueImgVerify" />
              </el-form-item>
              <p
                v-show="errorMsg"
                style="
                  color: #ed4014;
                  font-size: 12px;
                  text-align: right;
                  margin: 0 auto -20px;
                "
              >
                {{ errorMsg }}
              </p>
              <el-form-item
                class="login-btn-form-item"
                style="width: 100%; margin-top: 40px"
              >
                <el-button
                  class="login-button"
                  type="primary"
                  style="width: 100%"
                  @click="submitClick"
                  >登录</el-button
                >
              </el-form-item>
              <el-button
                :style="visibility"
                type="text"
                style="width: 100%"
                @click="forgetPwd"
                >忘记密码？</el-button
              >
            </el-form>
            <p v-if="loginType === '1'" class="tips">
              <span style="visibility: hidden">各行政机构管理员</span>
            </p>
            <p v-if="loginType === '2'" class="tips" :style="visibility">
              温馨提示：
              <br />无
              <span
                >各行政机构管理员、行政机构用户、学校管理员使用该入口登录</span
              >
              <br />
            </p>
            <p v-if="loginType === '3'" class="tips">
              温馨提示：
              <br />各行政机构管理员、行政机构用户、学校管理员使用该入口登录
            </p>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-row class="footer-row">
      <el-col :span="24">
        <p>&#169; 2020 {{ copyright }}</p>
        <p>技术支持：北京捷成世纪科技股份有限公司</p>
      </el-col>
    </el-row>
    <change-pass-editor
      :visible.sync="editorVisible"
      :schoolName="schoolName"
      @change-succ="resetForm"
    ></change-pass-editor>
  </div>
</template>

<script>
import _ from 'lodash'
import md5 from 'js-md5'
import qs from 'qs'
import vueImgVerify from '../components/common/vue-img-verify'
import ChangePassEditor from '../components/common/change-pass-editor/change-pass-editor'

export default {
  data () {
    var validateCapcha = (rule, value, callback) => {
      if (value.toLowerCase() !== this.$refs.vueImgVerify.imgCode.toLowerCase()) {
        this.$refs.vueImgVerify.draw()
        callback(new Error('请输入正确的验证码'))
      } else {
        callback()
      }
    }
    return {
      teacherRule: {
        username: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        capcha: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { validator: validateCapcha, trigger: 'blur' }
        ]
      },
      studentRule: {
        idCard: [{ required: true, message: '请输入身份证号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        capcha: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { validator: validateCapcha, trigger: 'blur' }
        ]
      },
      managerRule: {
        username: [{ required: true, message: '请输入用户名或手机号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        capcha: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { validator: validateCapcha, trigger: 'blur' }
        ]
      },
      checked: true,
      loginForm: { username: '', idCard: '', password: '', capcha: '' },
      loginTypes: [
        {
          name: '教师登录',
          value: '1'
        },
        {
          name: '学生登录',
          value: '2'
        },
        {
          name: '管理登录 ',
          value: '3'
        }
      ],
      loading: false,
      isAdmin: false,
      loginType: '1',
      error: [],
      imgCode: '',
      alterLoginLoading: false,
      editorVisible: false,
      schoolName: ''
    }
  },

  components: {
    vueImgVerify,
    ChangePassEditor
  },

  watch: {
    'loginForm.username': {
      handler (newVal, oldVal) {
        if (!newVal) {
          this.loginForm.password = ''
        }
      }
    }
  },

  computed: {
    visibility () { return this.loginType === '2' || !this.$regional.ResetPassword ? 'visibility: hidden;' : 'visibility: visible;' },
    rules () {
      if (this.loginType === '1') {
        return this.teacherRule
      } else if (this.loginType === '2') {
        return this.studentRule
      } else {
        return this.managerRule
      }
    },
    errorMsg () {
      if (this.error[0] && this.loginType === '1') {
        return '手机号或密码错误，请重新输入'
      } else if (this.error[0] && this.loginType === '2') {
        return '身份证号或密码错误，请重新输入'
      } else if (this.error[0] && this.loginType === '3') {
        return '用户名或密码错误，请重新输入'
      } else if (this.error[1]) {
        return '用户不存在'
      } else if (this.error[2]) {
        return '用户已锁定'
      }
    },
    title () {
      if (this.$regional.copyright === 'hengshui') {
        return '衡水市学生综合素质评价系统'
      } else if (this.$regional.copyright === 'guilin') {
        return '桂林市学生综合素质评价系统'
      } else if (this.$regional.copyright === 'wuxi') {
        return '无锡市学生发展服务平台'
      }
    },
    copyright () {
      if (this.$regional.copyright === 'hengshui') {
        return '衡水市教育局版权所有'
      } else if (this.$regional.copyright === 'guilin') {
        return '桂林市教育局版权所有'
      } else if (this.$regional.copyright === 'wuxi') {
        return '无锡市教育信息化管理与服务中心版权所有'
      }
    }
  },

  mounted () {
    document.addEventListener('keyup', this.keyPress, false)
    this.initAlterLogin()
    this.initLoginType()
  },

  destroyed () {
    document.removeEventListener('keyup', this.keyPress, false)
  },

  methods: {
    initAlterLogin () {
      if (this.$route.query.code) {
        this.alterLoginLoading = true
        let param = {
          grant_type: 'password',
          identity_type: 4,
          code: this.$route.query.code,
          client_id: 'test',
          client_secret: 'MTIzNDU2'
        }
        this.$xhrPost('/auth/oauth/token', qs.stringify(param), {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
          }
        }).then(rs => {
          this.loading = false
          this.error = []
          if (rs && rs.access_token) {
            window.localStorage.setItem('token', rs.access_token)
            window.localStorage.setItem('refreshToken', rs.refresh_token)
            this.$xhrGet(`/acc/whoami`).then(rs => {
              if (rs.code === 'SUCCESS') {
                rs.data.menus = this.filterMenus(rs.data.menus)
                this.$store.commit('user/login', rs.data)
                // 跳转 BUG可能性
                let levelOne = _.filter(rs.data.menus, { level: 1, type: 1 })
                let levelTwo = _.filter(rs.data.menus, { level: 2, type: 1 })
                let secondNav = _.filter(levelTwo, { parentId: levelOne[0].id, level: 2, type: 1 })
                if (secondNav.length === 0) {
                  this.$router.replace({ name: levelOne[0].name })
                } else {
                  this.$router.replace({ name: secondNav[0].name })
                }
              }
            })
          } else if (rs.error && rs.error_description === 'auth_error') {
            this.alterLoginLoading = false
            this.$message.error('未知用户，请先添加或联系管理员')
            this.$router.push({ name: 'Login' })
          } else if (rs.error && rs.error_description === 'user_locked') {
            this.alterLoginLoading = false
            this.$message.error('用户已锁定')
            this.$router.push({ name: 'Login' })
          } else if (rs.error && rs.error_description === 'unsupported_role') {
            this.alterLoginLoading = false
            this.$message.error('角色无权限')
            this.$router.push({ name: 'Login' })
          } else if (rs.error && rs.error_description === 'illegal_visit') {
            this.alterLoginLoading = false
            this.$message.error('授权失败')
            this.$router.push({ name: 'Login' })
          } else if (rs.error && rs.error_description === 'user_locked') {
            this.alterLoginLoading = false
            this.$message.error('用户已锁定')
            this.$router.push({ name: 'Login' })
          } else if (rs.error && rs.error_description === 'role_error') {
            this.alterLoginLoading = false
            this.$message.error('用户角色错误')
            this.$router.push({ name: 'Login' })
          }
        })
      } else {
        this.alterLoginLoading = false
      }
    },

    initLoginType () {
      let loginType = this.$route.query && this.$route.query.loginType
      if (loginType) {
        this.loginType = loginType
      }
      setTimeout(() => {
        this.$refs.loginForm.resetFields()
      }, 10)
    },

    keyPress (e) {
      if (e.keyCode === 13) {
        this.submitClick()
      }
    },

    changeLoginType (val) {
      setTimeout(() => {
        this.$refs.loginForm.resetFields()
      }, 10)
      this.loginType = val
      this.error = []
    },

    submitClick: function () {
      localStorage.clear()
      this.error = []
      let param = {
        grant_type: 'password',
        username: this.loginType !== '2' ? this.loginForm.username : this.loginForm.idCard,
        password: md5(this.loginForm.password + 'p@w123!@#'),
        identity_type: this.loginType,
        client_id: 'test',
        client_secret: 'MTIzNDU2'
      }
      this.$refs['loginForm'].validate(valid => {
        if (valid) {
          this.loading = true
          this.error = []
          this.$xhrPost('/auth/oauth/token', qs.stringify(param), {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
          }).then(rs => {
            this.loading = false
            this.error = []
            if (rs && rs.access_token) {
              window.localStorage.setItem('token', rs.access_token)
              window.localStorage.setItem('refreshToken', rs.refresh_token)
              this.$xhrGet(`/acc/whoami`).then(rs => {
                if (rs.code === 'SUCCESS') {
                  if (rs.data.role === 'institution_admin' || rs.data.role === 'school_admin' || rs.data.role === 'general_user' || rs.data.role === 'student' || rs.data.role === 'teacher') {
                    if (rs.data.defaultPassword) {
                      let str = '_admin'
                      let role = rs.data.role.split(str)[0]
                      this.schoolName = rs.data[role]
                      this.editorVisible = true
                      return
                    }
                  }
                  rs.data.menus = this.filterMenus(rs.data.menus)
                  this.$store.commit('user/login', rs.data)
                  // 跳转 BUG可能性
                  let levelOne = _.filter(rs.data.menus, { level: 1, type: 1 })
                  let levelTwo = _.filter(rs.data.menus, { level: 2, type: 1 })
                  let secondNav = _.filter(levelTwo, { parentId: levelOne[0].id, level: 2, type: 1 })
                  if (secondNav.length === 0) {
                    this.$router.replace({ name: levelOne[0].name })
                  } else {
                    this.$router.replace({ name: secondNav[0].name })
                  }
                }
              })
            } else if (rs.error && rs.error_description === 'auth_error') {
              this.error[0] = true
            } else if (rs.error && rs.error_description === 'user_locked') {
              this.error[2] = true
            } else if (rs.error && rs.error_description === 'role_error') {
              this.error[0] = true
            }
          })
        }
      })
    },

    forgetPwd () {
      this.$router.push({ name: 'ForgetPwd', query: { loginType: this.loginType } })
    },

    getImgCode (code) {
      this.imgCode = code
    },

    // 教师用户个性记录、素质报告、综合评价 当年级与班级共存时去除重复部分
    filterMenus (menus) {
      const hasMenu = {
        TeacherGradeJudge: false,
        TeacherClassJudge: false,
        TeacherGradeQualityReport: false,
        TeacherClassQualityReport: false,
        TeacherGradePersonaRecord: false,
        TeacherClassPersonaRecord: false
      }
      const menuCodes = Object.keys(hasMenu)

      for (let i = 0; i < menus.length; i++) {
        if (menuCodes.includes(menus[i].name)) {
          hasMenu[menus[i].name] = true
        }
      }
      for (let j = 0; j < menuCodes.length; j += 2) {
        if (hasMenu[menuCodes[j]] && hasMenu[menuCodes[j + 1]]) {
          menus = menus.filter(o => o.name !== menuCodes[j + 1])
        }
      }
      return menus
    },

    resetForm () {
      this.loginForm.password = ''
      this.loginForm.capcha = ''
    }
  }
}
</script>

<style lang="scss" scoped>
#login-container {
  background: url(../assets/bg.png);
  background-position: center;
  background-size: 100%;
  text-align: left;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}
.title {
  display: flex;
  justify-content: center;
  padding-top: 10vh;
  margin-bottom: 6vh;
}
.login-div {
  display: flex;
  align-items: center;
  justify-content: center;
  max-height: calc(100% - 216px);
}
.row-container {
  width: 850px;
  height: 550px;
  border-radius: 30px;
}
.right-row-container {
  height: 100%;
  width: 50%;
  padding: 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
}
.login-form {
  text-align: center;
  background-clip: padding-box;
  background: #fff;
  margin-top: 20px;
}
.login-remember {
  margin-bottom: 22px;
}
.login-tips p {
  line-height: 15px;
}
.forget-pwd {
  color: #5d94f3;
  font-size: 14px;
  text-align: right;
  margin: 0px auto 20px;
  cursor: pointer;
}
.span-button {
  color: #5e93f6;
  cursor: pointer;
  font-size: 14px;
}
// .el-form /deep/ .el-button.is-plain { background: #fff; }
// .el-form /deep/ .el-button.is-plain:hover { background: #eff4fe; color: #5e93f6; }
.login-type span {
  cursor: pointer;
}
/deep/ .el-input__inner {
  width: 100%;
  padding-left: 0;
  border-radius: 0;
  border-top-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 1px;
}
.capcha-form-item {
  margin-top: 30px;
  margin-bottom: 5px;
  text-align: left;
}
.capcha-form-item /deep/ .el-input {
  position: relative;
}
.img-verify {
  position: absolute;
  right: 0px;
  top: 15px;
}
.login-btn-form-item {
  margin-bottom: 5px;
}
.login-button {
  background: var(--theme-color);
  border-radius: 20px;
}
.common-label {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  font-weight: 400;
  color: #444444;
}
.capcha-label {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  font-weight: 400;
  color: #444444;
  display: block;
}
.tips {
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: #9b9b9b;
  line-height: 20px;
}
.login-type {
  height: 28px;
  z-index: 1;
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  margin-right: 1vw;
  cursor: pointer;
}
.active {
  position: relative;
  color: var(--theme-color);
  font-weight: 520;
}
.active::after {
  content: ' ';
  width: 72px;
  position: absolute;
  bottom: 0;
  left: -2px;
  border: 3px solid var(--theme-color);
  opacity: 0.5;
}
.footer-row {
  height: 20px;
  margin-top: 4.2vh;
  opacity: 0.8;
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  line-height: 20px;
  p {
    height: 15px;
    line-height: 15px;
    margin-bottom: 8px;
    text-align: center;
  }
}
.logo {
  background: url(../assets/logo-left.png);
  background-repeat: no-repeat;
  background-position: left;
}
.left-col {
  height: 100%;
  width: 50%;
}
/deep/ input::-webkit-input-placeholder {
  /* 修改字号，默认继承input */
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue